var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card-text',[_c('v-container',[_c('h2',[_vm._v("Class History for "+_vm._s(_vm.decodedEmail)+" ")]),_c('p',[_vm._v(_vm._s(_vm.attendanceForDancer))])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }